import { useRef, useEffect } from 'react';
import { useThree } from '@react-three/fiber';
import { OrbitControls } from '@react-three/drei';
import { ThreeDBarConfig } from '../config/threeDBarTypes';
import * as THREE from 'three';

export const useThreeDBarControls = (config: ThreeDBarConfig, sceneSize: number = 20) => {
    const { camera, gl } = useThree();
    const controlsRef = useRef<any>(null);

    // Handle Camera Presets
    useEffect(() => {
        if (!controlsRef.current) return;

        const controls = controlsRef.current;
        const duration = 1000; // ms (we might need a tweening lib for smooth anim, but direct set for now)

        // Reset position based on preset
        // We'll assume the scene is centered at 0,0,0
        const distance = Math.max(20, sceneSize * 1.5); // Adjust based on scene size

        switch (config.cameraPreset) {
            case 'top':
                camera.position.set(0, distance, 0);
                camera.lookAt(0, 0, 0);
                break;
            case 'side':
                camera.position.set(0, 0, distance);
                camera.lookAt(0, 0, 0);
                break;
            case 'isometric':
            default:
                camera.position.set(distance, distance, distance);
                camera.lookAt(0, 0, 0);
                break;
        }

        controls.update();
    }, [config.cameraPreset, camera]);

    // Handle Interaction Settings
    useEffect(() => {
        if (!controlsRef.current) return;
        const controls = controlsRef.current;

        controls.enableZoom = config.enableZoom;
        controls.enablePan = config.enablePan;
        controls.maxPolarAngle = config.constrainRotation ? Math.PI / 2 - 0.1 : Math.PI; // Don't go below ground

        controls.update();
    }, [config.enableZoom, config.enablePan, config.constrainRotation]);

    return { controlsRef };
};
